<template>
  <div class="login">
  <el-container>
      <form class="form_login" method="post">
        <table cellspacing="0" style="width: 100%; border: 0; margin: 0 0 0.4em 0;">
          <tbody>
            <tr data-ng-show="viewModel.appMode==''">
              <td style="height: 3em; width: 35%;text-align:right;">{{$t('message.ID_txt')}}：</td>
              <td style="width: 65%; text-align:left; vertical-align: top;" colspan="2">
                <el-input class="input-205" v-model="user.id1" placeholder="請輸入帳號" maxlength="20" tabindex="1" style="width:9.375em;"></el-input>
              </td>
            </tr>
            <tr data-ng-show="viewModel.appMode==''">
              <td style="height: 3em; text-align:right;">{{$t('message.PassW_txt')}}：</td>
              <td style="text-align:left; vertical-align: top;" colspan="2">
                <el-input class="input-205" type="password" v-model="user.id2" placeholder="22請輸入密碼" tabindex="2" style="width:9.375em;"></el-input>
              </td>
            </tr>
            <tr data-ng-show="viewModel.appMode==''">
              <td style="height: 3em; text-align:right;">{{$t('message.ValiC_txt')}}：</td>
              <td style="text-align: left; vertical-align: top;">
                <el-input class="input-205" v-model="user.id3" placeholder="2請輸入驗證碼" maxlength="6" tabindex="3" style="width:6em;"></el-input>
              </td>
              <td style="display:flex; padding: 0.3em;">
                <img v-if="captchaInfo != null" :src="captchaInfo" style="margin: 0 0 0 0; height: 2.25em;" alt=""><a href="#" style="padding: 5px 0.6em;" title="重新產生驗證碼" tabindex="4"  @click.prevent="getCaptcha()">
                  <i class="el-icon-refresh"></i>
                </a>
              </td>
            </tr>
            <tr>
              <td style="padding: 2em;" colspan="3">
                <el-button type="primary" tabindex="5" @click.prevent="login()">
                  <span class="glyphicon glyphicon-log-in" style="margin-right: 4px;"></span> {{$t('message.Sign_in')}}
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
  </el-container>
  </div> 
</template>

<script>
import { mapGetters } from 'vuex'
import vFooter from '@/components/common/FooterView'

export default {
  name: 'login',
  components: {
    vFooter
  },
  data () {
    return {
      user: {
        id1: '',
        id2: '',
        id3: '',
        isLogin: true
      },
      captchaInfo: null
    }
  },
  computed: {
    ...mapGetters('system', {
      settintInfo: 'getSetting'
    })
  },
  methods: {
    checkSaveData () {
      let msg = ''
 
      if (tools.isNull(this.user.id1)) {
        msg = '帳號';
      } else if (0 == this.user.id2) {
        msg = '密碼';
      }

      return msg
    },
    login: function () {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        var vm = this
        this.$http.put('./WebApi/Common/Authorized', this.user)
          .then((response) => {
            var tmpData = response.data
            if ((tmpData != null) && (tmpData.usrData.id === vm.user.id1)) {
              console.log('set Authorized' + tmpData.usrData.id)
              // vm.$store.dispatch('actionLogin', tmpData.usrData)
              // vm.$store.commit('actionLogin', tmpData.usrData)
              var usrData = tmpData.usrData
              vm.$store.dispatch('actionLogin', usrData)
              vm.user.id1 = ''
              vm.user.id2 = ''
              vm.user.id3 = ''
              this.$emit('getDefaultMenu', vm.sysId, false)
              //vm.$router.push({ path: 'main' })
            } else {
              vm.$message.error('請檢查帳號密碼是否輸入正確')
              vm.user.id1 = ''
              vm.user.id2 = ''
            }
          })
          .catch(function (error) {
            vm.$message.error('對不起,網路連線失敗' + error)
          })
      } else {
        this.$message.error('對不起,請輸入' + msg)
      }
    },
    getCaptcha: function () {
      var vm = this
      this.$http
        .get('./WebApi/Tools/GetCaptcha/')
        .then(function (response) {
          vm.captchaInfo = response.data
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created Login =====')
    this.getCaptcha()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.input-205 {
  height: 2.05em;
  padding: 0.2em;
}

.ncuthead_01 {
  position: relative;
  height: 102px;
  background: transparent;
  background-position: 0px 0px;
  display: contents;
}
.ncuttitle {
  left: 9.5em;
  padding-bottom: 0px;
  position: absolute;
  top: 1.15em;
  font-size: 2.25em;
  font-weight: bolder;
  color: #161823;
  font-family: -apple-system,system-ui,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;
}
.loginMenu {
  border-left: none;
  padding-left: 0;
  margin: 0;
  padding-right: .75em;
  line-height: 0.6;
  display: inline-block;
  list-style-type: none;
  list-style-position: inside;
  padding: .5em 0;
}
.itemMenu {
  border-left: 1px solid rgba(0,0,0,0.1);
  padding-left: .75em;
  padding-right: .75em;
  line-height: 0.6;
}
.form_login {
  width: 26.875em;
  height: 7em;
  margin: 4rem 8rem 12rem;
  text-align: center;
  padding-top: 20px;
  vertical-align: top;
  font-size: larger;
}
</style>



// WEBPACK FOOTER //
// src/components/LoginView.vue